const rawExhibitions = [
  {
    id: '01',
    label: 'Detak',
    sublabel: 'Pulse',
    subtitle: 'Exhibit 01',
    desc: `Pulse is a vibrant exhibition that harnesses the power of
childhood memories within us. Bold, bright, and full of energy,
the works by Liunic and Gula remind us of the liberating
imagination that refreshes our creativity. Celebrating the
energy of youth allows us to see the world with a fresh
perspective. Listen to the pulse of childhood freedom and let
that courage guide us once again.`,
    desc_indo: `Detak adalah pameran penuh warna yang memanfaatkan
kekuatan ingatan masa kecil dalam diri kita. Berani, cerah,
dan penuh energi, karya-karya Liunic dan Gula mengingatkan
kita tentang kebebasan imajinasi yang menyegarkan
kreativitas. Perayaan energi masa muda membuat kita
bisa melihat dunia dengan lebih segar. Dengarkan detak
kebebasan masa kecil dan biarkan keberanian itu kembali
memandu kita.`,
    poster_image: 'kin/assest/about/gallery/detak/poster.webp',
    poster_color: '',
    collaborators: [
      {
        name: 'Gula',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/detak/ava_gula.webp',
        href: 'https://www.instagram.com/_gula',
        desc: `<strong>Teguh Septian Arifianto (Gula)</strong> is a visual artist and
creative director based in Jakarta. He is known as
Gula (sugar), which stands for Gusto Laboratory or
Laboratory of Happiness. Gula has been actively
exhibiting his work since 2011 and participated in
Unknown Asia - Art Exchange 2017 in Osaka. <br/><br/> His
illustrative work emphasizes color, composition, and
character design, exploring a range of mediums
including wall, wood, canvas, and upcycled plastic.`,
        desc_indo: `<strong>Teguh Septian Arifianto (Gula)</strong> adalah seorang
perupa dan direktur kreatif yang berbasis di
Jakarta. Dia dikenal sebagai Gula, yang merupakan
singkatan dari Gusto Laboratory atau Laboratorium
Kebahagiaan. Gula telah aktif memamerkan
karyanya sejak 2011 dan berpartisipasi dalam
Unknown Asia - Art Exchange 2017 di Osaka. <br/><br/> Karya
ilustratifnya menekankan warna, komposisi, dan
desain karakter, dengan mengeksplorasi berbagai
medium termasuk dinding, kayu, kanvas, dan
plastik daur ulang.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/detak/detak-1.webp',
            name: 'DAY (2023)',
            info: 'Acrylic on Canvas, 90 x 90 cm',
            size: '90 x 90 cm',
          },
          {
            image: 'kin/assest/about/gallery/detak/detak-2.webp',
            name: 'NIGHT (2023)',
            info: 'Acrylic on Canvas, 90 x 90 cm',
            size: '90 x 90 cm',
          },
          {
            image: 'kin/assest/about/gallery/detak/detak-3.webp',
            name: 'BLOOM WIDLY (2023)',
            info: 'Mixed Media on Board, 56 x 40 x 25 cm',
            size: '56 x 40 x 25 cm',
          },
        ],
      },
      {
        name: 'Liunic',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/detak/ava_liunic.webp',
        href: 'https://www.instagram.com/liunic/',
        desc: `<strong>Martcellia Liunic</strong> (b. 1989) is known for her bright
and cheerful works. Based in Jakarta, she runs her
own art label called “Liunic on Things” and uses her
creative practice to express emotions and tell stories.
<br/><br/> Her work features colorful abstract shapes, animals,
and female characters. Liunic has collaborated with
various international brands. Her illustrations have
been featured in publications such as the “Society
of Illustrator 65 Jury Selections,” It’s Nice That, and
Frankie Magazine.`,
        desc_indo: `<strong>Martcellia Liunic</strong> (l.1989) dikenal dengan karya-
karyanya yang berwarna cerah dan karakter
yang ceria. Berbasis di Jakarta, ia menjalankan
label seni sendiri bernama “Liunic on Things”
dan menggunakan praktik kreatifnya untuk
mengekspresikan emosi dan menceritakan kisah.
<br/><br/> Karyanya menampilkan bentuk abstrak yang
berwarna-warni, hewan, dan karakter perempuan.
Liunic telah berkolaborasi dengan berbagai merek
internasional. Ilustrasinya telah muncul dalam
publikasi seperti “Society of Illustrator 65 Jury
Selections,” It’s Nice That, dan Frankie Magazine.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/detak/detak-4.webp',
            name: 'INNER CHILD SERIES (2023)',
            info: 'Gouache on paper, Ø 20cm',
            size: 'Ø 20cm',
          },
          {
            image: 'kin/assest/about/gallery/detak/detak-5.webp',
            name: 'BLOOM SERIES (2023)',
            info: 'Gouache on paper, 15 x 20 cm (A5 Postcard)',
            size: '15 x 20 cm (A5 Postcard)',
          },
          {
            image: 'kin/assest/about/gallery/detak/detak-6.webp',
            name: 'TENACIOUS FLIGHT (2023)',
            info: 'Acrylic on Canvas, 50 x 50 cm',
            size: '50 x 50 cm',
          },
          {
            image: 'kin/assest/about/gallery/detak/detak-7.webp',
            name: 'INNER CHILD SERIES (2023)',
            info: 'Oil Pastel on Paper, 10 x 15 cm (A6 Postcard)',
            size: '10 x 15 cm (A6 Postcard)',
          },
        ],
      },
    ],
  },
  {
    id: '02',
    label: 'Daur',
    sublabel: '',
    subtitle: 'Exhibit 02',
    desc: `‘Daur’ invites viewers to explore the relationship between art,
sustainability, and cycles. Featuring the works of Ika Vantiani
and Tennessee Caroline, this exhibition highlights the impact
of every choice we make on the environment. Through ‘Daur,’
we aim to spark conversations about the hope for a healthier
environment and encourage thoughtful reflection on our
decisions. Art serves to convey hope for a friendlier and more
sustainable future for all.`,
    desc_indo: `‘Daur’ mengajak pengunjung mengeksplorasi hubungan
antara seni, keberlanjutan, dan siklus. Menampilkan karya Ika
Vantiani dan Tennessee Caroline, pameran ini menyoroti
dampak setiap pilihan kita terhadap lingkungan. Melalui
‘Daur’, kami ingin memulai percakapan tentang harapan
untuk lingkungan yang lebih sehat dan mendorong refleksi
bijaksana tentang keputusan kita. Seni hadir untuk
menyampaikan harapan akan masa depan yang lebih ramah
dan berkelanjutan bagi semua.`,
    poster_image: 'kin/assest/about/gallery/daur/poster.webp',
    poster_color: '#9f92c5',
    collaborators: [
      {
        name: 'Tennessee Caroline',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/daur/ava_tennesse.webp',
        href: 'https://www.instagram.com/tennesseecaroline',
        desc: `<strong>Tennessee Caroline</strong> (b. 1980), known as Iten, is an artist
who was born and raised in Bandung. Iten graduated
from Bandung Institute of Technology with a degree in
Painting. Her artworks feature characters that depict a
girl with chubby cheeks and cynical eyes.<br/><br/>
Since 2004, Iten has been involved in various solo and
group exhibitions, including Art Jakarta presented by
Art Serpong Gallery 2024, a group exhibition by Art
IASR titled "Milestone" (2024), and her solo exhibition
"Symbiosis" in Shanghai, China (2023).`,
        desc_indo: `<strong>Tennessee Caroline</strong> (b.1980) atau sering dipanggil Iten
adalah seorang seniman yang lahir dan besar di
Bandung. Iten menempuh studinya di Institut
Teknologi Bandung jurusan Seni Lukis. Karya Iten
mempunyai ciri khas yang menghadirkan sosok anak
kecil perempuan berpipi tembam dan memiliki tatapan
yang sinis.<br/><br/>
Iten sudah terlibat dalam berbagai pameran tunggal
dan grup baik di dalam maupun luar negeri sejak 2004
seperti Art Jakarta dihadirkan oleh Art Serpong Gallery
2024, pameran kelompok Art IASR 2024: Milestone,
pameran tunggal “Symbiosis” di Shanghai, Cina (2023).`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/daur/daur-1.webp',
            name: 'BAKSO, ANYONE? | BRUNCH | BURGER COASTER (2024)',
            info: 'Acrylic on Recycled Plastic Board, 40 x 40 cm',
            size: '40 x 40 cm',
          },
          {
            image: 'kin/assest/about/gallery/daur/daur-2.webp',
            name: 'DAILY BREAD | PIZZAAA | SUSHI',
            info: 'Acrylic on Recycled Plastic Board, 40 x 40 cm',
            size: '40 x 40 cm',
          },
        ],
      },
      {
        name: 'Ika Vantiani',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/daur/ava_ika.webp',
        href: 'https://www.instagram.com/vantiani',
        desc: `<strong>Ika Vantiani</strong> is an Indonesian artist, curator, and crafter based in Jakarta. She graduated from The London Institute of Communications–Jakarta with an Advanced Diploma in Advertising.
Her work explores what it means to be a woman in today’s society, especially in relation to media and consumer culture. She primarily works with collage, which she expands into workshops, installations, and street art.<br/><br/>
Since 2009, Ika has participated in many exhibitions as both artist and curator, including Jakarta Biennale (2013), Art Jog (2018), and Humanity Youth Festival (2020). She is also a member of several artist collectives, such as Micro Galleries, The Collage Club, and It’s In Your Hands Collective.`,
        desc_indo: `<strong>Ika Vantiani</strong> adalah seniman, kurator, dan perajin asal Indonesia yang berbasis di Jakarta. Ia lulus dari The London Institute of Communications–Jakarta dengan gelar Advanced Diploma di bidang Periklanan.
Karyanya mengeksplorasi makna menjadi perempuan di masyarakat masa kini, khususnya dalam kaitannya dengan media dan budaya konsumsi. Ia menggunakan teknik kolase sebagai medium utama, yang kemudian dikembangkan ke dalam bentuk workshop, instalasi, dan street art.<br/><br/>
Sejak 2009, Ika telah terlibat dalam berbagai pameran sebagai seniman maupun kurator, di antaranya Jakarta Biennale (2013), Art Jog (2018), dan Humanity Youth Festival (2020). Ia juga merupakan anggota beberapa kolektif seniman seperti Micro Galleries, The Collage Club, dan It’s In Your Hands Collective.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/daur/daur-3.webp',
            name: 'CHAOTIC MIND (2023)',
            info: 'Paper Collage, 31 x 36 cm (Framed)',
            size: '31 x 36 cm (Framed)',
          },
          {
            image: 'kin/assest/about/gallery/daur/daur-4.webp',
            name: 'SHATTERED (2023)',
            info: 'Paper Collage, 36 x 36 cm (Framed)',
            size: '36 x 36 cm (Framed)',
          },
          {
            image: 'kin/assest/about/gallery/daur/daur-5.webp',
            name: 'WHICH ONE ARE YOU? (2023)',
            info: 'Paper Collage, 29,5 x 29,5 cm (Framed)',
            size: '29,5 x 29,5 cm (Framed)',
          },
          {
            image: 'kin/assest/about/gallery/daur/daur-6.webp',
            name: 'TRIPLETS (2022)',
            info: 'Paper Collage, 23 x 25,5 cm (Framed)',
            size: '23 x 25,5 cm (Framed)',
          },
          {
            image: 'kin/assest/about/gallery/daur/daur-7.webp',
            name: 'THAT CINDERELLA DRESS (2022)',
            info: 'Paper Collage, 30,5 x 35,5 cm (Framed)',
            size: '30,5 x 35,5 cm (Framed)',
          },
          {
            image: 'kin/assest/about/gallery/daur/daur-8.webp',
            name: 'THAT DOG WHO GOT AWAY (2017)',
            info: 'Paper Collage, 25 x 51 cm (Framed)',
            size: '25 x 51 cm (Framed)',
          },
          {
            image: 'kin/assest/about/gallery/daur/daur-9.webp',
            name: 'MIMPIMU KEMBANG API (2021)',
            info: 'Paper Collage, 25 x 31 cm (Framed)',
            size: '25 x 31 cm (Framed)',
          },
          {
            image: 'kin/assest/about/gallery/daur/daur-10.webp',
            name: 'THE MESS WE’RE IN (2018)',
            info: 'Mix Media, 23 x 31,5 cm',
            size: '23 x 31,5 cm',
          },
        ],
      },
    ],
  },
  {
    id: '03',
    label: 'Jelujur',
    sublabel: 'Stitch',
    subtitle: 'Exhibit 03',
    desc: `’Stitch’ celebrates the delicate and intricate art of stitching,
exploring the profound connection between thread and
expression. Featuring the works of Aphrodita Wibowo and Ria
Paramita, the exhibition presents a diverse array of
textile-based art, where each stitch transforms simple thread
into powerful narratives. Through their distinct approaches,
both artists invite viewers to experience the transformative
power of the stitch, weaving together past and present in a
creative and meaningful way.`,
    desc_indo: `‘Jelujur’ menyajikan seni menyulam yang halus dan
kompleks, mengeksplorasi hubungan mendalam antara
benang dan ekspresi. Menampilkan karya dari Aphrodita
Wibowo dan Ria Paramita, pameran ini menyajikan beragam
seni berbasis tekstil, dimana setiap jahitan mengubah
benang sederhana menjadi narasi yang penuh makna.
Melalui pendekatan masing-masing yang khas, kedua
seniman mengundang pengunjung untuk merasakan
kekuatan transformatif dari bordir, menjalin masa lalu dan
masa kini dalam cara yang kreatif dan bermakna.`,
    poster_image: 'kin/assest/about/gallery/jelujur/poster.webp',
    poster_color: '#5c967f',
    collaborators: [
      {
        name: 'Aphrodita Wibowo',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/jelujur/ava_aphrodita.webp',
        href: 'https://www.instagram.com/cemprut/',
        desc: `<strong>Aphrodita Wibowo</strong> (b. 1985), affectionately known as Cemprut by her
family since childhood, is a self-taught artist with nearly 15 years of
experience. Her works reflect creativity that is colorful, honest, and
spontaneous, inspired by daily life and personal emotions. Utilizing a
variety of media, Cemprut blends traditional crafts such as embroidery,
sewing, and paper cut collage with digital art, including NFTs.
<br/><br/>
Cemprut has been actively involved in several selected group exhibitions,
such as Pesta Boneka of Papermoon Puppet Theater (2018), Art Moments
Bali (2023), NFT NYC (2023), ART Jakarta (2024), and the Yogyakarta Arts
Festival (2024). She also initiated the "Crafting Sampai Keriting"
workshop and is an active participant in the creative arts market.`,
        desc_indo: `<strong>Aphrodita Wibowo</strong> (b.1985) atau sering dipanggil Cemprut sejak kecil oleh
keluarganya, Cemprut adalah seorang seniman otodidak selama hampir
15 tahun. Karyanya merefleksikan kreativitas yang penuh warna, jujur,
dan spontan yang terinspirasi oleh kehidupan sehari-hari dan perasaan
personal. Dengan menggunakan berbagai media, Cemprut
menggabungkan kerajinan tangan tradisional seperti sulam, jahit, dan
kolase paper cut dengan karya digital, termasuk NFT.
<br/><br/>
Cemprut aktif terlibat di beberapa pameran bersama terpilih seperti
Pesta Boneka Papermoon Puppet Theater (2018), Art Moments Bali
(2023), NFT NYC (2023), ART Jakarta (2024), Festival Kesenian Yogyakarta
(2024). Cemprut juga menginisiasi workshop kerajinan "Crafting Sampai
Keriting" dan aktif berpartisipasi dalam pasar seni kreatif.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-1.webp',
            name: 'Uwek - Uwek si Peri Owa! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 27,5 x 31,5 cm',
            size: '3D Frame : 27,5 x 31,5 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-2.webp',
            name: 'Lestari si Peri Gajah! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 27,5 x 31,5 cm',
            size: '3D Frame : 27,5 x 31,5 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-3.webp',
            name: 'Krucil si Peri Belalang! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 27,5 x 31,5 cm',
            size: '3D Frame : 27,5 x 31,5 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-4.webp',
            name: 'Muncak si Peri Rusa! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 27,5 x 31,5 cm',
            size: '3D Frame : 27,5 x 31,5 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-5.webp',
            name: 'Kukuk Beluk si Peri Burung Hantu! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 27,5 x 31,5 cm',
            size: '3D Frame : 27,5 x 31,5 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-6.webp',
            name: 'Ranting si Peri Burung! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 27,5 x 31,5 cm',
            size: '3D Frame : 27,5 x 31,5 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-7.webp',
            name: 'Beta si Peri Ikan! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 27,5 x 31,5 cm',
            size: '3D Frame : 27,5 x 31,5 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-8.webp',
            name: 'Kibut si Peri Bunga! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 27,5 x 31,5 cm',
            size: '3D Frame : 27,5 x 31,5 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-9.webp',
            name: 'Padma si Peri Bunga! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 27,5 x 31,5 cm',
            size: '3D Frame : 27,5 x 31,5 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-0.webp',
            name: 'Pertiwi! (2024)',
            info: 'Soft Sculpture from Fabric Scraps & Used Clothes Sewing Machine & Hand Embroidery, 3D Frame : 87 x 97 cm',
            size: '3D Frame : 87 x 97 cm',
          },
        ],
      },
      {
        name: 'Ria Paramita',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/jelujur/ava_ria.webp',
        href: 'https://www.instagram.com/_riaparamita_',
        desc: `<strong>Ria Paramita</strong> is an Indonesian embroidery artist currently based in Tokyo, Japan. Ria
completed her studies in Textile Design at the Bandung Institute of Technology and
began her career as a Textile Design lecturer in Bandung before choosing to become
a full-time homemaker. Ria started her artistic practice through the hobby of
embroidery, and with her dedication, she developed her practice by creating
embroidery kits, eventually becoming one of the creators for Leisure Arts in the
United States, as well as a contributor of tutorials for Love Embroidery Magazine.
<br/><br/>
Her works gained wider recognition when she appeared on the U.S. national TV show
The Balancing Act, celebrating the 50th anniversary of Leisure Arts. Additionally, Ria
collaborated with Lojel Hong Kong to bring her intricate embroidery works and
designs to a global audience.`,
        desc_indo: `<strong>Ria Paramita</strong> adalah seorang seniman serat Indonesia yang kini berdomisili
di Tokyo, Jepang. Ria menyelesaikan studi Desain Tekstil, Institut Teknologi
Bandung dan memulai kariernya sebagai Dosen Desain Tekstil di Bandung
sebelum memilih untuk menjadi ibu rumah tangga penuh waktu. Ria
memulai praktik artistiknya melalui hobi menyulam, dengan ketekunannya
Ria mengembangkan praktiknya dengan membuat kit menyulam hingga
menjadi salah satu kreatori untuk Leisure Arts Amerika Serikat, serta
kontributor tutorial untuk Love Embroidery Magazine.<br/><br/>
Karya-karyanya semakin dikenal ketika tampil di acara televisi nasional
Amerika Serikat, The Balancing Act, dalam rangka perayaan ulang tahun
ke-50 Leisure Arts. Selain itu, Ria juga berkolaborasi dengan Lojel Hong
Kong untuk membawa karya dan desain sulamnya yang kompleks ke
khalayak global.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-10.webp',
            name: 'Sudut Nyaman',
            info: 'Hand Embroidery on Cotton Linen, 13 x 22 cm',
            size: '13 x 22 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-11.webp',
            name: 'Siluet Urban Fashion Jepang',
            info: 'Hand Embroidery on Cotton Linen, 15 x 20 cm',
            size: '15 x 20 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-12.webp',
            name: 'Burung Kakatua',
            info: 'Hand Embroidery, Ø 16 cm',
            size: 'Ø 16 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-13.webp',
            name: 'Burung Kakatua',
            info: 'Hand Embroidery on Cotton Linen, 33 x 33 cm',
            size: '33 x 33 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-14.webp',
            name: 'Harapan Dibalik Sayap I',
            info: '3D Hand Embroidery, 14 x 18 cm',
            size: '14 x 18 cm',
          },
          {
            image: 'kin/assest/about/gallery/jelujur/jelujur-15.webp',
            name: 'Harapan Dibalik Sayap II',
            info: '3D Hand Embroidery, 14 x 18 cm',
            size: '14 x 18 cm',
          },
        ],
      },
    ],
  },
  {
    id: '04',
    label: 'Pengembara',
    sublabel: 'Voyager',
    subtitle: 'Exhibit 04',
    desc: `’VOYAGER’ presents three artists, Jamal M Aziz, Kathrin, and Sarkodit—each navigating a personal journey of growth and self-understanding.
Jamal reflects on a passive phase in his life through the symbol of a man in pajamas wearing a superhero mask, representing untapped potential restrained by comfort. Kathrin explores spirituality and her inner dialogue with God through symbolic elements such as a woman, ribbons, and flowers, creating a contemplative and fragile atmosphere. Meanwhile, Sarkodit is in an exploratory artistic phase, experimenting with different mediums and portraying male figures as a dialogue with his childhood and younger self.
Together, their works form a unified narrative about journey, the search for meaning, and the ongoing process of becoming.`,
    desc_indo: `PENGEMBARA menghadirkan tiga seniman—Jamal M. Aziz, Kathrin, dan Sarkodit—yang masing-masing berada dalam proses perjalanan personal untuk memahami diri dan terus bertumbuh.
Jamal merefleksikan fase pasif dalam hidupnya melalui simbol laki-laki berpiyama bertopeng superhero, sebagai gambaran potensi yang terhambat kenyamanan. Kathrin mengeksplorasi dimensi spiritual dan dialog batin dengan Tuhan lewat simbol perempuan, pita, dan bunga yang menghadirkan suasana reflektif dan rapuh. Sementara itu, Sarkodit berada dalam fase eksplorasi artistik, bereksperimen dengan medium dan menghadirkan figur laki-laki sebagai bentuk dialog dengan diri dan masa kecilnya.
Bersama, karya mereka membentuk satu narasi tentang perjalanan, pencarian makna, dan proses menjadi yang tak pernah berhenti.`,
    poster_image: 'kin/assest/about/gallery/pengembara/poster.webp',
    poster_color: '#d44410',
    collaborators: [
      {
        name: 'Jamal M.Aziz',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/pengembara/ava_jamal.webp',
        href: 'https://www.instagram.com/lapantigatiga',
        desc: `<strong>Jamal M. Aziz</strong> or known as
Lapantigatiga on social media, he
started his career as a graphic designer
for Endah N Rhesa Musician Duo, 2012 ,
despite his educational background in
Information Technology, he found a
passion in arts, mostly using
watercolor, ink, digital paint and also
canvas.
<br/><br/>
His works mostly talk about inner
monologues, self-reflection, and
sometimes glimpses of the past that
affect his present self recently, he has
been reinterpreting childhood
memories, particularly about
superheroes and childhood games.
Beside that, he built a mural studio
called Kapal Pecah Studio for a specific
and wider project with many styles
with some friends, and became a
fulltime illustrator from 2015 - present.`,
        desc_indo: `<strong>Jamal M. Aziz</strong> atau dikenal dengan
Lapantigatiga di media sosial,
mengawali kariernya sebagai desainer
grafis untuk duo musisi Endah N
Rhesa, 2012, meski berlatar belakang
pendidikan dalam Teknologi
Informasi, ia menemukan passion di
bidang seni, terutama menggunakan
cat air, tinta, melukis digital dan juga
kanvas.
<br/><br/>
Karya-karyanya lebih banyak
bercerita tentang monolog batin,
refleksi diri, dan terkadang kilasan
masa lalu yang kemudian
memengaruhi dirinya saat ini. Saat ini,
ia tengah menafsirkan ulang
kenangan masa kecilnya, terutama
tentang superhero dan permainan
masa kecil. Selain itu, ia mendirikan studio mural
bernama Kapal Pecah Studio untuk
proyek yang lebih spesifik dan lebih
luas dengan berbagai gaya bersama
beberapa temannya, dan menjadi
ilustrator penuh waktu dari tahun
2015 hingga sekarang.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/pengembara/layzyness.webp',
            name: 'Lazyness',
            info: 'Acrylic on Canvas, 40 x 40 cm',
            size: '40 x 40 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/waiting-nothing.webp',
            name: 'Waiting Nothing',
            info: 'Acrylic on Canvas, 40 x 40 cm',
            size: '40 x 40 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/over-lazy-think.webp',
            name: 'Over-Lazy-Think',
            info: 'Acrylic on Canvas, 40 x 40 cm',
            size: '40 x 40 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/sleep-walk.webp',
            name: 'Sleep Walk',
            info: 'Acrylic on Canvas, 40 x 40 cm',
            size: '40 x 40 cm',
          },
        ],
      },
      {
        name: 'Kathrin Honesta',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/pengembara/ava_kathrin.webp',
        href: 'https://www.instagram.com/kathrinhonestaa',
        desc: `<strong>Kathrin Honesta</strong> is an Indonesian
illustrator and a storyteller at heart.
She spins stories of tackling life and
faith, then turning them into visual
metaphors, adding depth to her
illustrations. She has made numerous
illustrations for book covers published
by Penguin Random House, Harper
Collins, Usborne Books, Google &
Disney.<br/><br/>
As part of her personal artistic
exploration, she is part of ‘Shadows
Stories’
, a collaborative project with
writer Kay Jen, that reimagines our
relationship with spirituality through
illustrated books and zines. She also
co-founded "Trinket By Kath"
, a lifestyle
brand producing little trinkets based on
her illustrations.`,
        desc_indo: `<strong>Kathrin Honesta</strong> adalah seorang
ilustrator Indonesia dan pendongeng
sejati. Ia memutar cerita tentang
kehidupan dan iman, lalu
mengubahnya menjadi metafora
visual, yang menambah kedalaman
ilustrasinya. Ia telah membuat banyak
ilustrasi untuk sampul buku yang
diterbitkan oleh Penguin Random
House, Harper Collins, Usborne Books,
Google & Disney.<br/><br/>
Sebagai bagian dari eksplorasi artistik
pribadinya, ia menjadi bagian dari
‘Shadows Stories’
, sebuah proyek
kolaborasi dengan penulis Kay Jen,
yang menata ulang hubungan kita
dengan spiritualitas melalui buku dan
zine bergambar. Ia juga mendirikan
"Trinket By Kath"
, sebuah merek gaya
hidup yang memproduksi pernak-
pernik kecil dari ilustrasinya.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/pengembara/humbled.webp',
            name: 'Humbled',
            info: 'Gouache on Canvas, 50 x 100 cm',
            size: '50 x 100 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/close-to-you.webp',
            name: 'Close to You',
            info: 'Gouache on Canvas, 60 x 60 cm',
            size: '60 x 60 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/in-loop-without-you.webp',
            name: 'In Loop, without You',
            info: 'Gouache on Canvas, 80 x 60 cm',
            size: '80 x 60 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/in-your-image.webp',
            name: 'In Your Image',
            info: 'Gouache on Canvas, 20 x 20 cm',
            size: '20 x 20 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/thinking-of-you.webp',
            name: 'Thinking of You',
            info: 'Gouache on Canvas, 30 x 30 cm',
            size: '30 x 30 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/seeking-you.webp',
            name: 'Seeking You',
            info: 'Gouache on Canvas, 50 x 50 cm',
            size: '50 x 50 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/you-save-me.webp',
            name: 'You save me',
            info: 'Gouache on Canvas, 60 x 50 cm',
            size: '60 x 50 cm',
          },
        ],
      },
      {
        name: 'Sarkodit',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/pengembara/ava_sarkodit.webp',
        href: 'https://www.instagram.com/sarkodit/',
        desc: `A man with an educational background in
Visual Communication Design from
ITENAS, Sarkodit enjoys playing with
deformative styles and exploring a wide
range of colors. He often creates
illustrations with strong narrative
elements, wrapped in a surreal and
metaphorical presentation.<br/><br/>
Sarkodit has illustrated several books,
such as Pemetik Bintang by Venerdi
Handoyo, Sore by Suryana Paramita, and
three children’s books titled Raya Sayang,
Tepuk Amai-Amai, and Bawang Merah
Bawang Putih, produced in collaboration
with a publisher from Singapore. His latest
book project features illustrations for a
short story collection titled Manusia Sore
Hari.<br/><br/>
Sarkodit won the Genkosha Illustration File
Award in Japan and was selected as one
of the Emerging Jakarta-Based Artists at
Exi(s)t 3 at Dia.Lo.Gue. Today, Sarkodit
works consistently as a freelance
illustrator and has collaborated with
various multinational brands such as
Google, Apple Music, Indofood, Lego, and
many others.`,
        desc_indo: `Seorang laki-laki yang berlatar belakang
pendidikan Desain Komunikasi Visual,
ITENAS ini senang bermain-main dengan
gaya deformatif dan melakukan eksplorasi
berbagai macam warna. Ia pun sering
membuat ilustrasi dengan komponen naratif
yang dibalut dengan kemasan surealis dan
penuh metafora.<br/><br/>
Sarkodit pun membuat ilustrasi untuk
beberapa buku, seperti Pemetik Bintang
karya Venerdi Handoyo, Sore karya Suryana
Paramita, juga tiga buku anak berjudul Raya
Sayang, Tepuk Amai-Amai, dan Bawang
Merah Bawang Putih, hasil kerjasamanya
dengan sebuah penerbit dari Singapura.
Karya untuk buku terbarunya adalah ilustrasi
untuk kumpulan cerita pendek berjudul
Manusia Sore Hari.<br/><br/>
Sarkodit memenangkan Genkosha
Illustration File Award Jepang, dan menjadi
bagian dari Emerging Jakarta Based Artists
pada Exi(s)t 3 di Dia.Lo.Gue, kini Sarkodit
konsisten menggeluti profesinya sebagai
ilustrator lepas yang telah bekerjasama
dengan berbagai brand multinasional,
seperti Google, Apple Music, Indofood, Lego,
dan lain-lain.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/pengembara/boys-dont-cry.webp',
            name: 'Boys Don’t Cry',
            info: 'Archival Ink on Wood Board Laser Cut, 31 x 31 cm',
            size: '31 x 31 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/fire-house.webp',
            name: 'Fire House',
            info: 'Archival Ink on Wood Board Laser Cut, 21.5 x 32 cm',
            size: '21.5 x 32 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/flower-head.webp',
            name: 'Flower Head',
            info: 'Archival Ink on Wood Board Laser Cut, 21.5 x 32 cm',
            size: '21.5 x 32 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/heardless-monster-and-the-eagle.webp',
            name: 'Heardless Monster and The Eagle',
            info: 'Archival Ink on Wood Board Laser Cut, 22 x 32.7 cm',
            size: '22 x 32.7 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/stalker-fountain.webp',
            name: 'Stalker Fountain',
            info: 'Archival Ink on Wood Board Laser Cut, 21.5 x 21.5 cm',
            size: '21.5 x 21.5 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/hands.webp',
            name: 'Hands',
            info: 'Archival Ink on Wood Board Laser Cut, 14 x 19 cm',
            size: '14 x 19 cm',
          },
          {
            image: 'kin/assest/about/gallery/pengembara/teasure.webp',
            name: 'Teasure',
            info: 'Archival Ink on Wood Board Laser Cut, 21.5 x 21.5 cm',
            size: '21.5 x 21.5 cm',
          },
        ],
      },
    ],
  },
  {
    id: '05',
    label: 'Utopia',
    sublabel: 'Utopia',
    subtitle: 'Exhibit 05',
    desc: `’UTOPIA’ presents the works of two Yogyakarta-born artists who explore the idea of utopia as a 
    reflective space for humanity’s longing for an ideal life. 
    Utopia is understood not only as an unreachable perfect world, but as a mirror of hope, inner conflict, 
    and the paradox between dreams and reality. 
    Through animal figures, vibrant colors, and imaginative surreal styles, the two artists transform anxiety and aspiration into poetic visual expressions. 
    This exhibition affirms that amid life’s uncertainties, humans continue to find the courage to dream and to nurture hope for a brighter future.`,
    desc_indo: `
   ’UTOPIA’ menampilkan karya dua seniman asal Yogyakarta yang mengeksplorasi gagasan utopia sebagai ruang reflektif tentang kerinduan manusia akan kehidupan yang ideal. 
   Utopia tidak hanya dipahami sebagai dunia sempurna yang tak terjangkau, 
   tetapi sebagai cerminan harapan, konflik batin, dan paradoks antara impian dan kenyataan.
    Melalui figur hewan, warna-warna ceria, serta gaya surealis yang imajinatif, kedua seniman menerjemahkan kegelisahan dan harapan menjadi visual yang puitis.
     Pameran ini menegaskan bahwa di tengah ketidakpastian hidup, manusia tetap memiliki keberanian untuk bermimpi dan memelihara harapan akan masa depan yang lebih baik.
`,
    poster_image: 'kin/assest/about/gallery/utopia/poster.webp',
    poster_color: '#2853a1',
    collaborators: [
      {
        name: 'Tulus Mulia',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/utopia/ava_tulus.webp',
        desc: `<strong>Tulus Mulia (b. 1996)</strong> was born and raised
in Yogyakarta. He is recognized for his
pop-surrealist paintings that blend
symbolism with powerful visual imagery.
In his works, Tulus often presents animal
characters connected to a world of
vibrant colors and imagination. For him,
the natural color palette and the lotus
flower symbol he employs represent
loyalty, goodwill, and hope.<br/><br/>
Tulus graduated from the Indonesia
Institute of the Arts in 2019. Since 2015, he
has participated in various exhibitions,
both nationally and internationally,
including ArtJakarta (2025), Amuya
Gallery, Jakarta (2024), 2Madison Gallery,
Jakarta (2023), and Misao Art
Corporation, Japan (2022), among others.`,
        desc_indo: `<strong>Tulus Mulia (l.1996)</strong> lahir dan besar di
Yogyakarta. Ia dikenal melalui karya-karya
lukisan pop surealis yang memadukan
simbolisme dengan citraan visual yang
kuat. Dalam karyanya, Tulus kerap
menghadirkan karakter hewan yang
terhubung dengan dunia penuh warna dan
imajinasi. Bagi Tulus, palet warna natural
serta simbol bunga teratai yang ia
gunakan merepresentasikan kesetiaan,
niat baik, dan harapan.<br/><br/>
Tulus menyelesaikan studinya di Institut
Seni Indonesia pada tahun 2019. Sejak
tahun 2015, ia telah berpartisipasi dalam
berbagai pameran, baik di tingkat nasional
maupun internasional, di antaranya
ArtJakarta (2025), Amuya Gallery, Jakarta
(2024), 2Madison Gallery, Jakarta (2023),
dan Misao Art Corporation, Jepang (2022),
serta sejumlah pameran lainnya.`,
        href: 'https://www.instagram.com/tulusmulia',
        artworks: [
          {
            image: 'kin/assest/about/gallery/utopia/bread-fish-and-the-light-of-aspirations.webp',
            name: 'Bread, Fish, and the Light of Aspirations',
            info: 'Acrylic on Canvas, 100 x 70 cm',
            size: '100 x 70 cm',
          },
          {
            image:
              'kin/assest/about/gallery/utopia/the-kids-2-dreams-and-hopes-in-bright-colors.webp',
            name: 'The Kids # 2 : Dreams and Hopes in Bright Colors',
            info: 'Acrylic on Canvas, 50 x 50 cm',
            size: '50 x 50 cm',
          },
          {
            image: 'kin/assest/about/gallery/utopia/eternal-connection.webp',
            name: 'Eternal Connection',
            info: 'Acrylic on Canvas, 50 x 50 cm',
            size: '50 x 50 cm',
          },
        ],
      },
      {
        name: 'Valentino Febri',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/utopia/ava_valentino.webp',
        desc: `<strong>Valentino Febri</strong> (b. 1992) was born into
an artist family in Yogyakarta. From an
early age, he showed a deep interest in
visual art, especially painting. His
naïve-style works often depict social
life, daily activities, and the beauty of
nature—reflecting warmth and a
contemplative view of his surroundings.<br/><br/>
A graduate of the Indonesian Institute
of the Arts (ISI) Yogyakarta, Valent has
held three solo exhibitions in Jakarta
(2014) and Yogyakarta (2015), and
actively participated in numerous
group shows, including Art Subs
(Surabaya, 2025), Art and Bali (Bali,
2025), and Art Life Indonesia
(Yogyakarta, 2024). He was also a
finalist in the Basuki Abdullah Art
Award (2022).`,
        desc_indo: `<strong>Valentino Febri</strong> (l. 1992) lahir dari keluarga
seniman di Yogyakarta. Sejak kecil, ia
menunjukkan ketertarikan besar pada
seni rupa, khususnya seni lukis. Karyanya
yang bergaya naïf kerap menampilkan
kehidupan sosial, aktivitas sehari-hari,
dan keindahan alam—menghadirkan
nuansa hangat dan reflektif terhadap
realitas di sekitarnya.<br/><br/>
Lulusan Institut Seni Indonesia (ISI)
Yogyakarta ini telah menggelar tiga
pameran tunggal di Jakarta (2014) dan
Yogyakarta (2015), serta aktif
berpartisipasi dalam berbagai pameran
bersama, seperti Art Subs (Surabaya,
2025), Art and Bali (Bali, 2025), dan Art
Life Indonesia (Yogyakarta, 2024). Ia juga
menjadi finalis Basuki Abdullah Art Award
pada tahun 2022.`,
        href: 'https://www.instagram.com/valentinofebri_',
        artworks: [
          {
            image: 'kin/assest/about/gallery/utopia/spirit-of-hope.webp',
            name: 'Spirit of Hope',
            info: 'Oil on Canvas, 60 x 60 cm',
            size: '60 x 60 cm',
          },
          {
            image: 'kin/assest/about/gallery/utopia/star.webp',
            name: 'Star',
            info: 'Oil on Canvas, 40 x 100 cm',
            size: '40 x 100 cm',
          },
          {
            image: 'kin/assest/about/gallery/utopia/moon.webp',
            name: 'Moon',
            info: 'Oil on Canvas, 40 x 100 cm',
            size: '40 x 100 cm',
          },
          {
            image: 'kin/assest/about/gallery/utopia/sun.webp',
            name: 'Sun',
            info: 'Oil on Canvas, 40 x 100 cm',
            size: '40 x 100 cm',
          },
        ],
      },
    ],
  },
  {
    id: '06',
    label: 'Merekah',
    sublabel: 'Unfolding',
    subtitle: 'Exhibit 06',
    desc: `Merekah (UNFOLDING), refers to a state
of opening—describing flowers in bloom, fruit
skins splitting open, cracked earth, and
layered objects that possess a “skin” or
surface. Beyond a physical transformation,
merekah signifies a process of transition,
unveiling, and formation that unfolds
naturally and continuously.`,
    desc_indo: `Merekah (UNFOLDING),
dimaknai sebagai kondisi terbuka—tentang
bunga yang mekar, kulit buah yang
terbelah, tanah yang retak, serta objek-
objek berlapis yang memiliki “kulit”. 

Lebih dari sekadar perubahan fisik, merekah
merepresentasikan sebuah proses:
peralihan, pembukaan, dan pembentukan
yang berlangsung secara alami dan
berkelanjutan.`,
    poster_image: 'kin/assest/about/gallery/merekah/poster.webp',
    poster_color: '#Ce4443',
    collaborators: [
      {
        name: 'Angga April',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/merekah/ava_angga.webp',
        href: 'https://www.instagram.com/anggapril_/',
        desc: `<strong>Angga April</strong> is a visual designer and
artist based in Bandung, Indonesia. His
practice navigates between
professional graphic design and
personal artistic exploration, allowing
both disciplines to inform and shape
one another. Drawing from close
observations of everyday life—small
routines, gestures, and quiet moments
—his process unfolds through sketching
and experimentation.`,
        desc_indo: `<strong>Angga April</strong> adalah desainer visual dan
perupa yang berbasis di Bandung,
Indonesia. Praktiknya bergerak di
antara kerja profesional desain grafis
dan eksplorasi seni personal, di mana
keduanya saling memengaruhi dan
membentuk satu sama lain. Berangkat
dari pengamatan terhadap keseharian
—rutinitas kecil, gestur, dan momen-
momen hening—proses kreatifnya
berkembang melalui sketsa dan
eksperimen visual.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/merekah/ranggas.webp',
            name: 'Ranggas',
            info: 'Pastel on Pastel Matt Paper, 18,8 x 24,6 cm',
            size: '18,8 x 24,6 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/widuri-rentan.webp',
            name: 'Widuri-Rentan',
            info: 'Acrylic on Canvas, 52 x 52 cm',
            size: '52 x 52 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/mengenang-menggenang.webp',
            name: 'Mengenang-Menggenang',
            info: 'Acrylic on Canvas, 42 x 52 cm',
            size: '42 x 52 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/himpit.webp',
            name: 'Himpit',
            info: 'Pastel on Pastel Matt Paper, 22 x 22 cm',
            size: '22 x 22 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/rembes.webp',
            name: 'Rembes',
            info: 'Pastel on Pastel Matt Paper, 22 x 22 cm',
            size: '22 x 22 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/peleburan.webp',
            name: 'Peleburan',
            info: 'Acrylic on Wood Panel, 20 x 20 cm',
            size: '20 x 20 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/udhik-udhik.webp',
            name: 'Udhik-Udhik',
            info: 'Acrylic on Wood Panel, 20 x 20 cm',
            size: '20 x 20 cm',
          },
        ],
      },
      {
        name: 'Nadia Diandra',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/merekah/ava_nadia.webp',
        href: 'https://www.instagram.com/nadia.diandra.art/',
        desc: `<strong>Nadia Diandra</strong> is an Indonesian visual
artist based in Yogyakarta. Her artistic
practice serves as a means of bringing
her inner child to life through color,
form, and imagination. Drawing from
everyday narratives and layered
emotional experiences, she translates
mixed feelings into vibrant palettes and
playful objects. The recurring sleepy
expressions and freckled details in her
characters function as subtle markers
of adulthood and lived experience.`,
        desc_indo: `<strong>Nadia Diandra</strong> adalah perupa visual
asal Indonesia yang berbasis di
Yogyakarta. Karya-karyanya menjadi
medium untuk menghidupkan kembali
inner child melalui warna, bentuk, dan
imajinasi. Ia merangkai cerita-cerita
keseharian dan beragam perasaan ke
dalam visual yang dipenuhi warna
cerah dan objek-objek yang playful,
dengan karakter khas seperti ekspresi
mata yang mengantuk dan detail
freckles sebagai refleksi perjalanan
menuju kedewasaan.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/merekah/connecting-people.webp',
            name: 'Connecting People',
            info: 'Acrylic on Canvas, 40 x 40 cm, 2023',
            size: '40 x 40 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/batu-loncatan.webp',
            name: 'Batu Loncatan',
            info: 'Acrylic on Canvas, 40 x 40 cm, 2023',
            size: '40 x 40 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/raining-flowers.webp',
            name: 'Raining Flowers',
            info: 'Acrylic on Canvas, 40 x 40 cm, 2022',
            size: '40 x 40 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/good-pool.webp',
            name: 'Good Pool',
            info: 'Acrylic on Canvas, 40 x 40 cm, 2023',
            size: '40 x 40 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/the-big-catch.webp',
            name: 'The Big Catch',
            info: 'Acrylic on Canvas, 25 x 25 cm, 2025',
            size: '25 x 25 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/bound-to-rise.webp',
            name: 'Bound to Rise',
            info: 'Acrylic on Canvas, 25 x 25 cm, 2025',
            size: '25 x 25 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/catching-chaos.webp',
            name: 'Catching Chaos',
            info: 'Acrylic on Canvas, 25 x 25 cm, 2025',
            size: '25 x 25 cm',
          },
        ],
      },
      {
        name: 'Stefany Zefanya',
        role: 'Artist',
        avatar: 'kin/assest/about/gallery/merekah/ava_stefany.webp',
        href: 'https://www.instagram.com/stefany.zefanya.art/',
        desc: `<strong>Stefany Zefanya</strong> is an Indonesian visual
artist working primarily with watercolor
and mixed media. Her practice engages
everyday experiences through
metaphorical forms, examining the
psychological and emotional
dimensions of human existence. Rooted
in an ongoing inquiry into the
complexity and multiplicity of the
human condition, her works reflect
moments of observation, introspection,
and becoming.`,
        desc_indo: `<strong>Stefany Zefanya</strong> adalah perupa visual asal
Indonesia yang bekerja terutama dengan
medium cat air dan mixed media. Praktiknya
berangkat dari pengalaman sehari-hari yang
diolah melalui bentuk-bentuk metaforis
untuk menelaah dimensi psikologis dan
emosional dari keberadaan manusia. Berpijak
pada ketertarikan yang berkelanjutan
terhadap kompleksitas dan keberagaman
kondisi manusia, karya-karyanya
merefleksikan momen-momen pengamatan,
perenungan, dan proses menjadi.`,
        artworks: [
          {
            image: 'kin/assest/about/gallery/merekah/ticking.webp',
            name: 'Ticking',
            info: 'Watercolor on CP Paper, 21 x 29 cm',
            size: '21 x 29 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/two-gather-1.webp',
            name: 'Two-gather I',
            info: 'Watercolor on CP Paper, @ 21,5 x 21 cm',
            size: '21,5 x 21 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/two-gather-2.webp',
            name: 'Two-gather II',
            info: 'Watercolor on CP Paper, @ 21,5 x 21 cm',
            size: '21,5 x 21 cm',
          },
          {
            image: 'kin/assest/about/gallery/merekah/two-gather-3.webp',
            name: 'Two-gather III',
            info: 'Watercolor on CP Paper, @ 21,5 x 21 cm',
            size: '21,5 x 21 cm',
          },
        ],
      },
    ],
  },
];

const toLocaleText = (value, fallback = '') => {
  if (value && typeof value === 'object') {
    const id = value.id ?? fallback;
    const en = value.en ?? id ?? fallback;
    return { id, en };
  }
  return { id: value ?? fallback, en: value ?? fallback };
};

const fromLegacyLocaleField = (entity, key, fallback = '') => {
  const id = entity?.[`${key}_indo`] ?? entity?.[`${key}_id`] ?? entity?.[key] ?? fallback;
  const en = entity?.[`${key}_eng`] ?? entity?.[`${key}_en`] ?? entity?.[key] ?? id ?? fallback;
  return { id, en };
};

const exhibitions = rawExhibitions.map((exhibition) => ({
  ...exhibition,
  locale: {
    label: toLocaleText(exhibition.locale?.label ?? fromLegacyLocaleField(exhibition, 'label')),
    sublabel: toLocaleText(
      exhibition.locale?.sublabel ?? fromLegacyLocaleField(exhibition, 'sublabel'),
    ),
    subtitle: toLocaleText(
      exhibition.locale?.subtitle ?? fromLegacyLocaleField(exhibition, 'subtitle'),
    ),
    desc: toLocaleText(exhibition.locale?.desc ?? fromLegacyLocaleField(exhibition, 'desc')),
  },
  collaborators: (exhibition.collaborators || []).map((artist) => ({
    ...artist,
    locale: {
      role: toLocaleText(artist.locale?.role ?? fromLegacyLocaleField(artist, 'role')),
      desc: toLocaleText(artist.locale?.desc ?? fromLegacyLocaleField(artist, 'desc', '')),
    },
    artworks: (artist.artworks || []).map((art) => ({
      ...art,
      locale: {
        name: toLocaleText(art.locale?.name ?? fromLegacyLocaleField(art, 'name')),
        info: toLocaleText(art.locale?.info ?? fromLegacyLocaleField(art, 'info')),
      },
    })),
  })),
}));

export { exhibitions };
